import { Card, Row, Col, Button } from "react-bootstrap";

export const TRANSACTION_TYPES = [
  {
    id: "agent_report",
    label: "COD Report",
    payementDirectionLabel: "Paid By FE",
    color: "primary",
    desc: "Field Executive’s delivery report & COD summary",
  },
  {
    id: "user_payin",
    label: "FE To Office",
    payementDirectionLabel: "Paid By FE",
    color: "success",
    desc: "Field Executive depositing COD amount to office",
  },
  {
    id: "user_payout",
    label: "Office to FE",
    payementDirectionLabel: "Paid To FE",
    color: "info",
    desc: "Office paying commission or salary to Field Executive or Employee",
  },
  {
    id: "office_expense",
    label: "Office Expense",
    payementDirectionLabel: "Paid By Office",
    color: "warning",
    desc: "Record daily office expenses like rent, fuel, or stationery",
  },
  {
    id: "owner_collection",
    label: "Owner Collection",
    payementDirectionLabel: "Withraw By Owner",

    color: "danger",
    desc: "Owner collecting daily cash from office",
  },
  {
    id: "adjustment",
    label: "Balance Adjustment",
    color: "secondary",
    desc: "Manual balance adjustment by admin or auditor",
  },
  {
    id: "commission_settlement",
    label: "Commission Settlement",
    color: "secondary",
    desc: "Automated commission calculation by system",
    disableRecordTr: true,
  },
];

const ALL_TRANSACTION_TYPES = [...TRANSACTION_TYPES];

export const isRecordAllowedForTrType = (type) => {
  const trData = ALL_TRANSACTION_TYPES.find((x) => x.id === type);
  return !!trData && !trData.disableRecordTr;
};

export const formatTypeLabel = (type, transactionTypes) =>
  transactionTypes?.find((x) => x.id === type)?.label ||
  ALL_TRANSACTION_TYPES.find((x) => x.id === type)?.label ||
  type;

export const formatTypeLabelForPaymentDirection = (type) =>
  ALL_TRANSACTION_TYPES.find((x) => x.id === type)?.payementDirectionLabel ||
  type;

const SelectTransactionTypeStep = ({
  data,
  onSubmit,
  allowedTransactionTypes,
}) => (
  <div className="p-3">
    <h5 className="text-center mb-4 fw-bold">Select Transaction Type</h5>

    <Row xs={1} sm={2} md={3} className="g-3">
      {(allowedTransactionTypes || TRANSACTION_TYPES)
        .filter((x) => !x.disableRecordTr)
        .map((type) => (
          <Col key={type.id} className="d-flex">
            <Card
              className={`flex-fill text-center shadow-sm border-${
                type.color
              } ${
                data.transactionType === type.id ? `border-3 shadow-lg` : ""
              }`}
              onClick={() => onSubmit({ transactionType: type.id })}
              style={{
                transition: "transform 0.15s ease-in-out",
                cursor: "pointer",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-3px)")
              }
              onMouseLeave={(e) => (e.currentTarget.style.transform = "none")}
            >
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title className={`text-${type.color} fw-bold mb-2`}>
                    {type.label}
                  </Card.Title>
                  <Card.Text className="small text-muted">
                    {type.desc}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
    </Row>
  </div>
);

export default SelectTransactionTypeStep;
